'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @external {CollectionQuery} https://github.com/Reading-eScience-Centre/coverage-jsapi/blob/master/CoverageCollectionQuery.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _constants = require('./constants.js');

var _Coverage = require('./Coverage.js');

var _Coverage2 = _interopRequireDefault(_Coverage);

var _util = require('./util.js');

var _covutils = require('covutils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** 
 * Wraps a CoverageJSON Collection object as a CoverageCollection API object.
 * 
 * @see https://github.com/Reading-eScience-Centre/coverage-jsapi
 * 
 */
var CoverageCollection = function () {
  /**
   * @param {Object} covjson The CoverageJSON Collection document.
   */
  function CoverageCollection(covjson) {
    _classCallCheck(this, CoverageCollection);

    /**
     * The constant "CoverageCollection".
     * 
     * @type {string}
     */
    this.type = _constants.COVERAGECOLLECTION;

    /**
     * JSON-LD document
     * 
     * @type {Object}
     */
    this.ld = {};

    this._exposeLd(covjson);

    this.prefixes = (0, _util.getNamespacePrefixes)(this.ld);

    /** 
     * ID of the coverage collection.
     * 
     * @type {string|undefined} 
     */
    this.id = covjson.id;

    var domainType = covjson.domainType;
    if (domainType && domainType.indexOf(':') === -1) {
      domainType = _util.DOMAINTYPES_PREFIX + domainType;
    }

    /**
     * If defined, every coverage in the collection has the given domain type, typically a URI.
     * 
     * @type {string|undefined}
     */
    this.domainType = domainType;

    var covs = [];
    var rootParams = covjson.parameters ? covjson.parameters : {};
    // generate local parameter IDs if not existing
    // this is to keep track of same parameters when copied into the coverages
    // (e.g. to synchronize legends etc.)
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(rootParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _key = _step.value;

        var param = rootParams[_key];
        if (!param.id) {
          param.id = Math.round(new Date().getTime() * Math.random()).toString();
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var covOptions = {};
    if (covjson.referencing) {
      covOptions.referencing = covjson.referencing;
    }
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = covjson.coverages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var coverage = _step2.value;

        if (!coverage.domainType) {
          coverage.domainType = domainType;
        }
        if (!coverage.parameters) {
          coverage.parameters = {};
        }
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = Object.keys(rootParams)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _key2 = _step4.value;

            if (_key2 in coverage.ranges) {
              coverage.parameters[_key2] = rootParams[_key2];
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (covjson['@context']) {
          coverage['@context'] = covjson['@context'];
        }
        covs.push(new _Coverage2.default(coverage, covOptions));
      }

      /** 
       * The Coverages of this collection.
       * 
       * @type {Array<Coverage>} 
       */
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    this.coverages = covs;
    if (covjson.parameters) {
      /**
       * A Map from key to {@link Parameter} object.
       * The key is a short alias of a {@link Parameter}, typically what is called a "variable name" or similar.
       * 
       * @type {Map<string,Parameter>}
       */
      this.parameters = new Map();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = Object.keys(covjson.parameters)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          (0, _Coverage.transformParameter)(covjson.parameters, key);
          this.parameters.set(key, covjson.parameters[key]);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
    if (covjson.domainTemplate) {
      (0, _Coverage.transformDomain)(covjson.domainTemplate);
      /**
       * @ignore
       */
      this.domainTemplate = covjson.domainTemplate;
    }
  }

  /**
   * 
   * @return {CollectionQuery}
   */


  _createClass(CoverageCollection, [{
    key: 'query',
    value: function query() {
      return new _covutils.CollectionQuery(this);
    }
  }, {
    key: '_exposeLd',
    value: function _exposeLd(covjson) {
      if (!covjson['@context']) {
        // no LD love here...
        return;
      }
      // make a deep copy since the object gets modified in-place later
      // but first, remove the coverages (those have their own .ld property)
      var copy = (0, _util.shallowcopy)(covjson);
      delete copy.coverages;
      this.ld = JSON.parse(JSON.stringify(copy));
    }
  }]);

  return CoverageCollection;
}();

exports.default = CoverageCollection;